import React from 'react';
import { BookOpen, Eye } from 'lucide-react';
const samplePages = [{
  chapter: 'Chapter 3 · Oaxaca',
  title: 'Mole Negro de Oaxaca',
  desc: 'The 7-chile secret + the peanut butter shortcut that fooled my chef mentor.',
  color: '#3E2723',
  accent: '#FACC15'
}, {
  chapter: 'Chapter 5 · Baja',
  title: 'Glass-Batter Fish Tacos',
  desc: 'The exact beer + flour ratio for the crackle every Baja chef hides.',
  color: '#14B8A6',
  accent: '#FBF7F0'
}, {
  chapter: 'Chapter 8 · Riviera Maya',
  title: 'Slow Cooker Cochinita Pibil',
  desc: 'Mayan BBQ that simmers overnight — wake up to resort-quality meat.',
  color: '#C2410C',
  accent: '#FACC15'
}];
export function SamplePreview() {
  return <section className="w-full py-16 md:py-24 bg-[#FBF7F0]" data-id="element-384">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-385">
        <div className="text-center mb-12" data-id="element-386">
          <div className="inline-flex items-center gap-2 bg-[#C2410C] text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-4" data-id="element-387">
            <Eye className="w-3.5 h-3.5" data-id="element-388" />
            Take a Peek Inside
          </div>
          <h2 className="text-4xl md:text-5xl text-[#3E2723] mb-4" data-id="element-389">
            See What's Inside the Playbook
          </h2>
          <p className="text-xl text-[#3E2723]/70 max-w-2xl mx-auto" data-id="element-390">
            Three sample pages from the 20-page masterclass — fully unlocked
            when you grab your copy.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-391">
          {samplePages.map((page, idx) => <div key={idx} className="relative bg-white rounded-xl shadow-xl overflow-hidden transform transition-transform hover:-translate-y-2 duration-300" style={{
          rotate: idx === 1 ? '0deg' : idx === 0 ? '-2deg' : '2deg'
        }} data-id="element-392">
              <div className="p-5 text-white" style={{
            backgroundColor: page.color
          }} data-id="element-393">
                <div className="text-xs uppercase tracking-widest mb-1 font-bold" style={{
              color: page.accent
            }} data-id="element-394">
                  {page.chapter}
                </div>
                <h3 className="text-xl font-bold leading-tight" data-id="element-395">
                  {page.title}
                </h3>
              </div>
              <div className="p-5 bg-[#F5F1E8]" data-id="element-396">
                <p className="text-sm text-[#3E2723]/80 italic mb-4" data-id="element-397">
                  "{page.desc}"
                </p>
                <div className="space-y-2 mb-3" data-id="element-398">
                  <div className="h-2 bg-[#3E2723]/15 rounded w-full" data-id="element-399"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-11/12" data-id="element-400"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-4/5" data-id="element-401"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-full" data-id="element-402"></div>
                  <div className="h-2 bg-[#3E2723]/15 rounded w-3/4" data-id="element-403"></div>
                </div>
                <div className="flex items-center gap-2 text-xs font-bold text-[#C2410C] uppercase tracking-wider pt-3 border-t border-[#3E2723]/10" data-id="element-404">
                  <BookOpen className="w-3.5 h-3.5" data-id="element-405" />
                  Page {idx === 0 ? '08' : idx === 1 ? '12' : '17'} of 20
                </div>
              </div>
              <div className="absolute inset-0 pointer-events-none" style={{
            background: 'linear-gradient(to top, rgba(251,247,240,0.6) 0%, transparent 30%)'
          }} data-id="element-406"></div>
              <a href="#offer" className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-[#3E2723] hover:bg-[#C2410C] text-white text-xs font-bold px-4 py-2 rounded-full uppercase tracking-wider shadow-lg transition-colors cursor-pointer" data-id="element-407">
                🔒 Unlock Full Recipe
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}